// extracted by mini-css-extract-plugin
export var placeholder = "VideoComponent-module--placeholder--mKtJZ";
export var ratio = "VideoComponent-module--ratio--MIEDc";
export var wrapper = "VideoComponent-module--wrapper--BwOYi";